// superadmin_nav
import { Auth } from "@/api";

// App inventory (project terpisah, origin beda) tidak bisa baca localStorage
// dashboard utama. Session di-handoff lewat query string saat user klik menu
// Inventory; app inventory baca query string ini di awal lalu simpan ke
// localStorage-nya sendiri (lihat apps/web/src/main.js). oke
function buildInventoryUrl() {
  const base = process.env.VUE_APP_INVENTORY_URL || "http://localhost:5173/";
  const params = new URLSearchParams({
    token: Auth.Session.get("paradigm_token") || "",
    id: Auth.Session.get("paradigm_id") || "",
    role: Auth.Session.get("paradigm_role") || "",
    username: Auth.Session.get("paradigm_username") || "",
    login_name: Auth.Session.get("paradigm_login_name") || "",
    branch_id: Auth.Session.get("paradigm_branch_id") || "",
  });
  return `${base}?${params.toString()}`;
}

let navItem = [
  {
    id: 1,
    name: "Dashboard",
    url: "/dashboard",
    icon: "icon-home",
  },
  {
    id: 2,
    name: "Site Configuration",
    url: "/siteConfiguration",
    icon: "icon-settings",
  },
  {
    id: 3,
    name: "Sales",
    url: "/sales",
    icon: "icon-folder",
  },
  {
    id: 4,
    name: "Sales Manager",
    url: "/salesManager",
    icon: "icon-folder",
  },
  {
    id: 5,
    name: "Customer Services",
    url: "/customerService",
    icon: "icon-folder",
  },
  {
    id: 6,
    name: "Personal Training",
    url: "/personalTraining",
    icon: "icon-folder",
  },
  {
    id: 7,
    name: "Form",
    url: "/allForm",
    icon: "icon-book-open",
  },
  {
    id: 8,
    name: "Leads",
    url: "/leads",
    icon: "icon-folder",
  },
  {
    id: 9,
    name: "Online Register",
    url: "/app_leads",
    icon: "icon-folder",
  },
  {
    id: 10,
    name: "Branch",
    url: "/branch",
    icon: "icon-briefcase",
  },
  {
    id: 11,
    name: "Member Data",
    url: "/memberData",
    icon: "icon-folder",
  },
  {
    id: 12,
    name: "Register Wristband",
    url: "/registerWristband",
    icon: "icon-doc",
  },
  {
    id: 13,
    name: "Product",
    url: "/ptSession",
    icon: "icon-folder",
  },
  {
    id: 14,
    name: "Buy PT Session",
    url: "/ptSessionBuy",
    icon: "icon-folder",
  },
  {
    id: 15,
    name: "Member",
    url: "/ptSessionMember",
    icon: "icon-folder",
  },
  {
    id: 16,
    name: "Calendar",
    url: "/myCalendar",
    icon: "icon-calendar",
  },
  {
    id: 17,
    name: "Membership",
    url: "/membership",
    icon: "icon-notebook",
  },
  {
    id: 18,
    name: "Slide Banner",
    url: "/slideBanner",
    icon: "icon-picture",
  },
  {
    id: 19,
    name: "Schedule",
    url: "/schedule",
    icon: "icon-folder",
  },
  {
    id: 20,
    name: "Classes",
    url: "/classes",
    icon: "icon-folder",
  },
  {
    id: 21,
    name: "Classes Time",
    url: "/classesTime",
    icon: "icon-folder",
  },
  {
    id: 22,
    name: "Studio",
    url: "/studio",
    icon: "icon-folder",
  },
  {
    id: 23,
    name: "Instructor",
    url: "/coach",
    icon: "icon-folder",
  },
  {
    id: 24,
    name: "FAQ",
    url: "/faq",
    icon: "icon-directions",
  },
  {
    id: 25,
    name: "Event",
    url: "/event",
    icon: "icon-trophy",
  },
  {
    id: 26,
    name: "Package",
    url: "/package",
    icon: "icon-paper-clip",
  },
  {
    id: 27,
    name: "Blog",
    url: "/blog",
    icon: "icon-folder",
  },
  {
    id: 28,
    name: "Blog Cateogry",
    url: "/blogCategory",
    icon: "icon-folder",
  },
  {
    id: 29,
    name: "Gallery",
    url: "/gallery",
    icon: "icon-camera",
  },
  {
    id: 30,
    name: "Data Entry",
    url: "/memberEntry",
    icon: "icon-user",
  },
  {
    id: 31,
    name: "Class Attendance",
    url: "/class_attendance",
    icon: "icon-folder",
  },
  {
    id: 32,
    name: "Gym Attendance",
    url: "/gym_attendance",
    icon: "icon-folder",
  },
  {
    id: 33,
    name: "Booking History",
    url: "/booking_history",
    icon: "icon-folder",
  },
  {
    id: 34,
    name: "Transaction History",
    url: "/transaction_history",
    icon: "icon-folder",
  },
  {
    id: 35,
    name: "Guest Register",
    url: "/salesReport/guestRegister",
    icon: "icon-folder",
  },
  {
    id: 36,
    name: "Sales Log",
    url: "/salesReport/salesLog",
    icon: "icon-folder",
  },
  {
    id: 37,
    name: "Sales Back to Basic",
    url: "/salesReport/salesBackToBasic",
    icon: "icon-folder",
  },
  {
    id: 38,
    name: "Daily DPR",
    url: "/salesReport/dailyDPR",
    icon: "icon-folder",
  },
  {
    id: 39,
    name: "Sales Best of the Best",
    url: "/salesReport/salesBestOfTheBest",
    icon: "icon-folder",
  },
  {
    id: 40,
    name: "Freeze",
    url: "/formReport/freeze",
    icon: "icon-folder",
  },
  {
    id: 41,
    name: "Cancel",
    url: "/formReport/cancel",
    icon: "icon-folder",
  },
  {
    id: 42,
    name: "Outstanding",
    url: "/formReport/outstanding",
    icon: "icon-folder",
  },
  {
    id: 91,
    name: "Auto Collection",
    url: "/formReport/autocollection",
    icon: "icon-folder",
  },
  {
    id: 43,
    name: "Wristband",
    url: "/formReport/wristband",
    icon: "icon-folder",
  },
  {
    id: 44,
    name: "Lost & Found",
    url: "/formReport/lostAndFound",
    icon: "icon-folder",
  },
  {
    id: 45,
    name: "Daily Visit",
    url: "/formReport/dailyVisit",
    icon: "icon-folder",
  },
  {
    id: 46,
    name: "Grab & Go",
    url: "/formReport/grabAndGo",
    icon: "icon-folder",
  },
  {
    id: 47,
    name: "History",
    url: "/settlement/history",
    icon: "icon-folder",
  },
  {
    id: 48,
    name: "Submit",
    url: "/settlement/submit",
    icon: "icon-folder",
  },
  {
    id: 49,
    name: "Group Fitness Attendance",
    url: "/groupFitness/attendance",
    icon: "icon-folder",
  },
  {
    id: 50,
    name: "Group Fitness Comission",
    url: "/groupFitness/comission",
    icon: "icon-folder",
  },
  {
    id: 51,
    name: "PT Planner",
    url: "/ptPlanner",
    icon: "icon-folder",
  },
  {
    id: 52,
    name: "PT Log",
    url: "/ptReport/ptLog",
    icon: "icon-folder",
  },
  {
    id: 53,
    name: "PT Back to Basic",
    url: "/ptReport/ptBackToBasic",
    icon: "icon-folder",
  },
  {
    id: 54,
    name: "PT Best of the Best",
    url: "/ptReport/ptBestOfTheBest",
    icon: "icon-folder",
  },
  {
    id: 55,
    name: "Member PHA",
    url: "/memberPha",
    icon: "icon-folder",
  },
  {
    id: 56,
    name: "Usage Log",
    url: "/ptReport/usageLog",
    icon: "icon-folder",
  },
  {
    id: 57,
    name: "Sub Category",
    url: "/memberDiary/subCategory",
    icon: "icon-folder",
  },
  {
    id: 58,
    name: "Activity",
    url: "/memberDiary/activity",
    icon: "icon-folder",
  },
  {
    id: 59,
    name: "User CRM",
    url: "/userManagement/user",
    icon: "icon-folder",
  },
  {
    id: 60,
    name: "User Role",
    url: "/userManagement/userRole",
    icon: "icon-folder",
  },
  {
    id: 61,
    name: "User Access Menu",
    url: "/userManagement/userAccessMenu",
    icon: "icon-folder",
  },
  {
    id: 62,
    name: "User Role Mapping",
    url: "/userManagement/userRoleMapping",
    icon: "icon-folder",
  },
  {
    id: 63,
    name: "Group Fitness CNR",
    url: "/groupFitness/cnr",
    icon: "icon-folder",
  },
  {
    id: 64,
    name: "Member PHA History",
    url: "/memberPhaHistory",
    icon: "icon-folder",
  },
  {
    id: 65,
    name: "Member Privilege",
    url: "/memberPrivilege",
    icon: "icon-present",
  },
  {
    id: 66,
    name: "Corporate",
    url: "/corporate",
    icon: "icon-present",
  },
  {
    id: 67,
    name: "History",
    url: "/keysoft/history",
    icon: "icon-present",
  },
  {
    id: 68,
    name: "Sync",
    url: "/keysoft/sync",
    icon: "icon-present",
  },
  {
    id: 69,
    name: "Assign Member PHA",
    url: "/memberPhaAssign",
    icon: "icon-present",
  },
  {
    id: 70,
    name: "Member PHA Appointment",
    url: "/memberPhaAppointment",
    icon: "icon-present",
  },
  {
    id: 71,
    name: "Group Fitness Summary",
    url: "/groupFitness/summary",
    icon: "icon-folder",
  },
  {
    id: 72,
    name: "Grab n Go Gopay",
    url: "/formReport/grabAndGoGopay",
    icon: "icon-folder",
  },
  {
    id: 73,
    name: "Corporate Outstanding",
    url: "/formReport/corporateOutstanding",
    icon: "icon-folder",
  },
  {
    id: 74,
    name: "Member Wristband",
    url: "/memberWristband",
    icon: "icon-folder",
  },
  {
    id: 75,
    name: "Transfer Leads",
    url: "/transferLeads",
    icon: "icon-folder",
  },
  {
    id: 76,
    name: "Member Privilege Category",
    url: "/memberPrivilegeCategory",
    icon: "icon-folder",
  },
  {
    id: 77,
    name: "Class Category",
    url: "/classCategory",
    icon: "icon-folder",
  },
  {
    id: 78,
    name: "Membership Session Prorate",
    url: "/membershipSessionProrate",
    icon: "icon-folder",
  },
  {
    id: 79,
    name: "Group Fitness",
    url: "/frontendSetting/groupFitness",
    icon: "icon-folder",
  },
  {
    id: 80,
    name: "PHA",
    url: "/frontendSetting/pha",
    icon: "icon-folder",
  },
  {
    id: 81,
    name: "Program",
    url: "/frontendSetting/program",
    icon: "icon-folder",
  },
  {
    id: 82,
    name: "Video Home",
    url: "/frontendSetting/videoHome",
    icon: "icon-folder",
  },
  {
    id: 83,
    name: "Video GF",
    url: "/frontendSetting/videoGF",
    icon: "icon-folder",
  },
  {
    id: 84,
    name: "Video PT",
    url: "/frontendSetting/videoPT",
    icon: "icon-folder",
  },
  {
    id: 85,
    name: "Paradigm Standard",
    url: "/frontendSetting/paradigmStandard",
    icon: "icon-folder",
  },
  {
    id: 86,
    name: "Sales Mapping",
    url: "/salesMapping",
    icon: "icon-folder",
  },
  {
    id: 87,
    name: "Studio Schedule",
    url: "/frontendSetting/studioSchedule",
    icon: "icon-folder",
  },
  {
    id: 88,
    name: "Notification",
    url: "/notification",
    icon: "icon-folder",
  },
  {
    id: 90,
    name: "PT Planner New",
    url: "/ptPlannerNew",
    icon: "icon-folder",
  },
  {
    id: 93,
    name: "Schedule PT Appointment",
    url: "/schedulePtAppointment",
    icon: "icon-folder",
  },
  {
    id: 92,
    name: "Report Outstanding",
    url: "/keysoft/reportOutstanding",
    icon: "icon-present",
  },
  {
    id: 95,
    name: "Komisi Sales",
    url: "/ptReport/salesCommission",
    icon: "icon-folder",
  },
  {
    id: 96,
    name: "Sales Planner",
    url: "/salesPlanner",
    icon: "icon-folder",
  },
  {
    id: 97,
    name: "Face App Logs",
    url: "/logs/faceLogs",
    icon: "icon-folder",
  },
  {
    id: 98,
    name: "ExtenD PT",
    url: "/formReport/extend",
    icon: "icon-folder",
  },
  {
    id: 99,
    name: "Autopay Midtrans",
    url: "/formReport/autopay_midtrans",
    icon: "icon-folder",
  },
  {
    id: 100,
    name: "Bank Draft",
    url: "/formReport/draft_bank",
    icon: "icon-folder",
  },
  {
    id: 101,
    name: "Group Fitness Report",
    url: "/attendance/group_fitness",
    icon: "icon-folder",
  },
  {
    id: 121,
    name: "Best of Best GF",
    url: "/groupFitness/best-of-the-best",
    icon: "icon-folder",
  },
  {
    id: 122,
    name: "Instructor Attendance",
    url: "/attendance/instructor",
    icon: "icon-folder",
  },
  {
    id: 102,
    name: "Member Voucher",
    url: "/memberVoucher",
    icon: "icon-folder",
  },
  {
    id: 103,
    name: "Voucher",
    url: "/vouchers",
    icon: "icon-briefcase",
  },
  {
    id: 104,
    name: "Bank Book",
    url: "/finance/bank-book",
    icon: "icon-folder",
  },
  {
    id: 105,
    name: "Membership Log",
    url: "/finance/membership-log",
    icon: "icon-folder",
  },
  {
    id: 106,
    name: "Revenue Log",
    url: "/finance/revenue-log",
    icon: "icon-folder",
  },
  {
    id: 107,
    name: "PT Log",
    url: "/finance/pt-log",
    icon: "icon-folder",
  },
  {
    id: 108,
    name: "PT Running",
    url: "/finance/pt-running",
    icon: "icon-folder",
  },
  {
    id: 109,
    name: "Last Dues Recog",
    url: "/finance/last-dues-recognition-log",
    icon: "icon-folder",
  },
  {
    id: 110,
    name: "Merchandise Log",
    url: "/finance/merchandise-log",
    icon: "icon-folder",
  },
  {
    id: 111,
    name: "Closing Period",
    url: "/closingPeriod",
    icon: "icon-folder",
  },
  {
    id: 112,
    name: "Merchandise",
    url: "/formReport/merchandise",
    icon: "icon-folder",
  },
  {
    id: 113,
    name: "Term Membership",
    url: "/finance/term_membership",
    icon: "icon-folder"
  },
  {
    id: 114,
    name: "Cancel Log",
    url: "/logs/cancelLogs",
    icon: "icon-folder",
  },
  {
    id: 115,
    name: "PT Session Analysis",
    url: "/finance/pt-session-analysis",
    icon: "icon-folder"
  },
  {
    id: 116,
    name: "Membership Analysis",
    url: "/finance/membership-analysis",
    icon: "icon-folder"
  },
  {
    id: 117,
    name: "Member Voucher Report",
    url: "/formReport/member_voucher_report",
    icon: "icon-folder"
  },
  {
    id: 118,
    name: "Log Update FOP",
    url: "/formReport/log_update_fop",
    icon: "icon-folder"
  },
  {
    id: 119,
    name: "Collect Stamp",
    url: "/collectStamp",
    icon: "icon-folder"
  },
  {
    id: 120,
    name: "Running PT Balance",
    url: "/finance/running_pt_balance",
    icon: "icon-folder"
  },
  {
    id: 123,
    name: "Group Fitness BOTB",
    url: "/attendance/group_fitness_botb",
    icon: "icon-folder",
  },
  {
    id: 124,
    name: "Member Point Report",
    url: "/formReport/member-point-report",
    icon: "icon-folder"
  },
  {
    id: 125,
    name: "Member Point Scheme",
    url: "/memberPointScheme",
    icon: "icon-folder"
  },
  {
    id: 126,
    name: "Redeem Point",
    url: "/finance/redeem_point",
    icon: "icon-folder"
  },
  {
    id: 154,
    name: "AutoPay",
    url: "/report/autopay",
    icon: "icon-folder"
  },
  {
    id: 155,
    name: "Motto",
    url: "/report/motto",
    icon: "icon-folder"
  },
  {
    id: 156,
    name: "Auto Collection",
    url: "/report/autoCollection",
    icon: "icon-folder"
  },
  {
    id: 157,
    name: "Autopay Results",
    url: "/report/autopayresults",
    icon: "icon-folder"
  },
  {
    id: 158,
    name: "Outstanding Report",
    url: "/report/outstanding",
    icon: "icon-folder"
  },
  {
    id: 161,
    name: "PT Feedback Report",
    url: "/report/ptfeedback",
    icon: "icon-folder"
  },
  {
    id: 164,
    name: "Session Expired",
    url: "/report/session-expired",
    icon: "icon-folder"
  },
  {
    id: 159,
    name: "Approval Roles",
    url: "/userManagement/approval-roles",
    icon: "icon-folder",
  },
  {
    id: 160,
    name: "Inventory",
    url: buildInventoryUrl(),
    icon: "icon-folder"
  },
  {
    id: 162,
    name: "Bookings",
    url: "/memberBookings",
    icon: "icon-folder"
  },
];
let navParent = JSON.parse(Auth.Session.get("paradigm_app_menus")) ? JSON.parse(Auth.Session.get("paradigm_app_menus")) : [];
// OLD NAV HARDCODE
// let navParent = [
//   {
//     items: [5, 6, 23, 59, 60, 61, 62],
//     name: "User Management",
//     icon: "icon-people",
//   },
//   {
//     items: [3, 4, 86],
//     name: "Sales",
//     icon: "icon-graph",
//   },
//   {
//     items: [8, 9, 75],
//     name: "Leads",
//     icon: "icon-graph",
//   },
//   {
//     items: [11, 55, 64, 69, 70],
//     name: "Member Data",
//     icon: "icon-loop",
//   },
//   {
//     items: [13, 14, 15],
//     name: "PT Session",
//     icon: "icon-bulb",
//   },
//   {
//     items: [17, 78],
//     name: "Membership",
//     icon: "icon-folder",
//   },
//   {
//     items: [19, 20, 21, 22, 77],
//     name: "Classes Schedule",
//     icon: "icon-calendar",
//   },
//   {
//     items: [27, 28],
//     name: "Blog",
//     icon: "icon-book-open",
//   },
//   {
//     items: [31, 32, 101, 121, 122, 123],
//     name: "Attendance",
//     icon: "icon-graph",
//   },
//   {
//     items: [33, 34],
//     name: "History",
//     icon: "icon-pie-chart",
//   },
//   {
//     items: [65, 76],
//     name: "Member Privilege",
//     icon: "icon-doc",
//   },
//   {
//     items: [35, 36, 37, 38, 39],
//     name: "Sales Report",
//     icon: "icon-pie-chart",
//   },
//   {
//     items: [40, 41, 42, 43, 44, 45, 46, 72, 73, 91, 98, 99, 100, 112, 117, 118, 124],
//     name: "Form Report",
//     icon: "icon-doc",
//   },
//   {
//     items: [47, 48],
//     name: "Settlement",
//     icon: "icon-doc",
//   },
//   {
//     items: [49, 50, 63, 71],
//     name: "Group Fitness",
//     icon: "icon-doc",
//   },
//   {
//     items: [52, 53, 54, 56, 95],
//     name: "PT Report",
//     icon: "icon-doc",
//   },
//   {
//     items: [57, 58],
//     name: "Master Diary",
//     icon: "icon-doc",
//   },
//   {
//     items: [67, 68, 92],
//     name: "Keysoft",
//     icon: "icon-doc",
//   },
//   {
//     items: [79, 80, 81, 82, 83, 84, 85, 87],
//     name: "Frontend Setting",
//     icon: "icon-doc",
//   },
//   {
//     items: [97, 114],
//     name: "Logs",
//     icon: "icon-doc",
//   },
//   {
//     items: [102],
//     name: "Member Voucher",
//     icon: "icon-doc",
//   },
//   {
//     items: [104, 105, 106, 107, 108, 109, 110, 113, 111, 115, 116, 120, 126],
//     name: "Finance",
//     icon: "icon-doc",
//   },
//   {
//     items: [119],
//     name: "Collect Stamp",
//     icon: "icon-doc",
//   },
//   {
//     items: [125],
//     name: "Member Point Scheme",
//     icon: "icon-doc",
//   },
// ];

let nav = [];

function getNavParent(id) {
  let item = false;
  for (let i = 0; i < nav.length; i++) {
    let row = nav[i];
    if (!row.items) {
      // console.log('asd')
    } else {
      row.items.forEach((itemId) => {
        if (itemId == id) item = row;
      });
    }
  }

  return item;
}

let session = Auth.Session.get("paradigm_access_menu");
let accessMenu = session ? session.split(",") : [];

accessMenu.forEach((id) => {
  let item = navItem.find((item) => item.id == id);
  if (item) {
    let parent = navParent.find((parent) => {
      return parent.items.includes(parseInt(id));
    });

    let realParent = getNavParent(id);

    if (!parent) nav.push(item);
    else if (realParent && realParent) {
      realParent.children.push(item);
    } else {
      let temp = Object.assign({}, parent);
      if (!temp.children) temp.children = [item];
      else temp.children.push(item);

      nav.push(temp);
    }
  }
});

// console.log(JSON.stringify(nav))
localStorage.setItem('paradigm_cached_menus', JSON.stringify(nav))

export default {
  items: nav,
  navItem,
};
